import { render, staticRenderFns } from "./SalesPackages.vue?vue&type=template&id=61ec10a2&scoped=true&"
import script from "./SalesPackages.vue?vue&type=script&lang=js&"
export * from "./SalesPackages.vue?vue&type=script&lang=js&"
import style0 from "./SalesPackages.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SalesPackages.vue?vue&type=style&index=1&id=61ec10a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ec10a2",
  null
  
)

export default component.exports